import { ControlValveAnimatic } from '@crossnokaye/ux-animatics';

import { AnimaticControlValveConfigKind } from '@repo/sdk/models/components';

import { ANIMATIC_PRIMARY_LABEL } from '@/features/equipment-browser/animatics/constants';
import { getLabel } from '@/features/equipment-browser/animatics/helpers';
import { convertPercentToDecimal, getRefValue } from '@/features/equipment-browser/utils';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticControlValve = ({ config, labels, state, className }: AnimaticConfigProps) => {
  const valueRef = config.specificAnimaticConfig?.controlValve?.valueRef;
  const value = valueRef ? convertPercentToDecimal(getRefValue(valueRef)) : undefined;
  // The BFF SHOULD always set this but because it is required by the animatic, we default to pneumatic here to be safe
  const kind: AnimaticControlValveConfigKind =
    config.specificAnimaticConfig?.controlValve?.kind ?? AnimaticControlValveConfigKind.Pneumatic;
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);

  return (
    <ScaledAnimatic className={className} scaleX={0.98} scaleY={0.98}>
      <ControlValveAnimatic
        label={primaryLabel?.text}
        state={state}
        type={kind as 'motorized' | 'icad' | 'pneumatic' | 'king'}
        value={value}
      />
    </ScaledAnimatic>
  );
};
